import { Box, InputBase, ListItem, styled, Tab, Tabs } from '@mui/material';
import { TabPanel } from '@mui/lab';

export const GeneralSearchInput = styled(InputBase)<{
  amendmode?: string;
}>`
  padding: 10px;
  width: 100%;

  border-radius: 8px;

  ${(prop) =>
    prop.amendmode === 'true' &&
    `
    border-radius: 8px 8px 0 0;
  `}

  background: ${(props) => props.theme.palette.white.main};
  & input {
    font-size: 16px;
    margin-left: 1rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;

export const StyledTabs = styled(Tabs)`
  min-width: auto;
  min-height: auto;
  padding: ${(props) => props.theme.spacing(1)};
  border-bottom: 1px solid #e0e0e0;

  .MuiButtonBase-root.Mui-disabled {
    background-color: #e0e0e0;
  }
`;

export const StyledTab = styled(Tab)(({ theme }) => ({
  borderRadius: 24,
  fontWeight: 700,
  fontSize: theme.typography.button.fontSize,
  marginLeft: theme.spacing(1),
  padding: '8px 12px',
  minHeight: 'auto',
  minWidth: 'auto',
  color: theme.palette.text.primary,
  '&.Mui-selected': {
    color: theme.palette.white.main,
    backgroundColor: theme.palette.primary.main,
  },
  '&.Mui-focusVisible': {
    backgroundColor: theme.palette.primary.main,
  },
}));

export const StyledTabPanel = styled(TabPanel)<{ floatingmode?: string }>`
  padding: 0;
  max-height: ${(props) => (props.floatingmode === 'true' ? '50vh' : '100vh')};
  overflow-y: auto;
`;

export const OptionsContainer = styled(Box)<{
  floatingmode?: string;
  dialogmode?: string;
}>`
  border-radius: ${(prop) => prop.dialogmode !== 'true' && '0 0 16px 16px'};
  box-shadow: ${(prop) =>
    prop.floatingmode === 'true' &&
    '0 1px 3px rgb(60 63 66 / 32%), 0 4px 12px rgb(60 63 66 / 15%)'};

  background: ${(props) => props.theme.palette.white.main};
  padding-bottom: 30px;
  overflow: hidden;
`;

export const EmptyContainer = styled(Box)`
  padding: ${(props) => props.theme.spacing(2)};
`;

export const StyledListItem = styled(ListItem)`
  border-bottom: 1px solid #e0e0e0;
  padding: 0;

  a {
    text-decoration: none;
    width: 100%;
    padding: 10px 16px;
  }
` as any;
